import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import ScrollableAlert from '../Alerts/ScrollableAlert';
const CameraPermissionPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [showAlert, setShowAlert] = useState(false);
    const { t } = useTranslation('shared');
    useEffect(() => {
        const checkCameraAccess = async () => {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({ video: true });
                stream.getTracks().forEach((track) => track.stop());
                navigate(`/creditApplication/${id}`, { replace: true });
            }
            catch {
                // Reste sur la page si l'accès échoue
            }
        };
        void checkCameraAccess();
    }, [id, navigate]);
    const requestCameraAccess = async () => {
        try {
            const permission = await navigator.permissions.query({ name: 'camera' });
            if (permission.state === 'denied') {
                setShowAlert(true);
                return;
            }
            const stream = await navigator.mediaDevices.getUserMedia({ video: true });
            stream.getTracks().forEach((track) => track.stop());
            navigate(`/creditApplication/${id}`, { replace: true });
        }
        catch (err) {
            console.error('Camera access denied or error:', err);
            setShowAlert(true);
        }
    };
    return (_jsxs("main", { className: "step-0", children: [showAlert && (_jsx(ScrollableAlert, { type: "warn", showAlert: showAlert, message: t('vouched.vouched.cameraPermission.stillNoPermission') })), _jsx("h4", { style: { marginTop: '5rem', marginBottom: '2rem' }, children: t('vouched.vouched.cameraPermission.noPermission') }), _jsx("div", { style: { display: 'flex', alignItems: 'center' }, children: _jsx("button", { type: "button", className: "btn btn-blue btn primary-action-btn", style: {
                        marginTop: 0,
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        textAlign: 'center',
                    }, onClick: requestCameraAccess, children: t('vouched.vouched.cameraPermission.button') }) })] }));
};
export default CameraPermissionPage;
